import * as React from "react";
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FileModel } from "../../../models/fileModel";
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import * as Constants from '../../../common/constants';
import { ImportSyncMedicineGridModel } from "../../../models/dataSynchronization";
import DataSyncService from '../../../services/dataSyncService';
import { ImportSyncDataFilterSettingsModel } from "../../../models/dataSynchronization";
import { ImportDataListModel } from "../../../models/dataSynchronization";
import { getEnumLabel } from '../../../common/functions/helperFunctions';
import { ImportedDataStatus, Lang } from '../../../common/enums';
import { SyncDataStatus } from '../../../common/enums';
import { ImportDataFilter } from './importDataFilter';
import { Toolbar } from 'primereact/toolbar';
import { ImportEmaMedicineModel } from "../../../models/dataSynchronization";
import { ImportAdminMedicineModel } from "../../../models/dataSynchronization";
import { ImportDataWrapperModel } from "../../../models/dataSynchronization";
import { ImportDataResultModel } from "../../../models/dataSynchronization";
import { SyncDataResultModel } from "../../../models/dataSynchronization";
import { UpdateDataResultModel } from "../../../models/dataSynchronization";
import ImportDataEditDialog from './importDataEditDialog';
import { EmaDataRowModel } from "../../../models/dataSynchronization";
import ImportDataAddNewDialog from './importDataAddNewDialog';
import { EmaDataRowContentModel } from "../../../models/dataSynchronization/emaDataRowContentModel";

interface IProps {
}

interface IState {
  isLoading: boolean;
  error: any;
  isVisibleConfirmDialog: boolean;
  isVisibleImportDataEditDialog: boolean;
  validationMessage: string;
  loadMessage: string;
  selectedFile: any;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  currentGridMedicine: ImportSyncMedicineGridModel;
  importedRows: Array<ImportSyncMedicineGridModel>;
  importDataFiterSettings: ImportSyncDataFilterSettingsModel;
  currentImportedMedicine: ImportEmaMedicineModel;
  currentAdminMedicine: ImportAdminMedicineModel;
  currentRawData: EmaDataRowModel;
  isVisibleAddNewDialog: boolean;
}

const initFrom = 0;
const numberOfRows = 10;

class ImportDataContainer extends React.Component<IProps, IState> {
  growl: any;
  refFile: any;
  currentFile: FileModel;
  dataSyncService = new DataSyncService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      loadMessage: '',
      isLoading: false,
      isVisibleConfirmDialog: false,
      isVisibleImportDataEditDialog: false,
      selectedFile: null,
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      currentGridMedicine: new ImportSyncMedicineGridModel(),
      importedRows: new Array<ImportSyncMedicineGridModel>(),
      importDataFiterSettings: new ImportSyncDataFilterSettingsModel(),
      currentImportedMedicine: new ImportEmaMedicineModel(),
      currentAdminMedicine: new ImportAdminMedicineModel(),
      currentRawData: new EmaDataRowModel(),
      isVisibleAddNewDialog: false
    };
  }

  componentDidMount() {
    this.getAll(this.state.from, this.state.numberOfRows);
  }

  getAll = (from: number, numberOfRows: number) => {
    this.setState({
      isLoading: true
    });

    this.dataSyncService.getAllImported(from, numberOfRows, this.state.importDataFiterSettings)
      .then(
        (data: ImportDataListModel) => {
          this.setState({
            isLoading: false,
            from: from,
            importedRows: data.importedMedicineData,
            totalRecordsCount: data.totalRecordsCount
          });
        },
        error => {
          this.setState({
            error
          });
          this.setState({
            isLoading: false
          });
        }
      );
  }

  getImported = (id) => {
    this.dataSyncService.getImported(id)
      .then(
        (data: ImportSyncMedicineGridModel) => {
          this.setcurrenDataSourceRow(data);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  setcurrenDataSourceRow(row: ImportSyncMedicineGridModel) {
    this.setState({ currentGridMedicine: { ...row } });
  }

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAll(startIndex, this.state.numberOfRows);
  }

  handleDeleteClick = (id) => {
    // this.getImported(id);
    // this.setState({
    //   isVisibleConfirmDialog: true
    // });
  };

  deleteDataSource = (id) => {
    // this.setState({
    //   isVisibleConfirmDialog: false,
    //   isLoading: true
    // });

    // this.dataSyncService.deleteDataSourceRow(id)
    //   .then(
    //     data => {
    //       this.getAll(this.state.from, this.state.numberOfRows);
    //       this.setState({
    //         isLoading: false
    //       });
    //     },
    //     error => {
    //       this.setState({
    //         error,
    //         isLoading: false
    //       });
    //     });
  }

  handleImportedMedicineEditClick = (importedMedicineId: number) => {
    this.setState({
      isLoading: true
    });

    this.dataSyncService.getImportedAndSyncData(importedMedicineId)
      .then(
        (data: ImportDataWrapperModel) => {
          this.setCurrentImportAndAdminMedicine(data);
          this.showEditDialog(true);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        }
      );
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleImportDataEditDialog: show,
      validationMessage: ''
    })
  };

  handleSyncTODBButton = (adminMedicine: ImportAdminMedicineModel, close: boolean) => {
  };

  handleUpdateMedicineButton = (adminMedicine: ImportAdminMedicineModel, close: boolean) => {
    this.setState({
      isLoading: true
    });

    this.dataSyncService.updateSyncData(adminMedicine)
      .then(
        (data) => {
          if (close) {
            this.showEditDialog(false);
          }
          this.getAll(this.state.from, this.state.numberOfRows);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.showEditDialog(false);
          this.setState({
            error
          });
          this.setState({
            isLoading: false
          });
        }
      );
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  setCurrentImportAndAdminMedicine(importMedicine: ImportDataWrapperModel) {
    let emaMedicine = importMedicine.emaMedicine;
    let adminMedicine = importMedicine.adminMedicine;

    this.setState({
      currentImportedMedicine: emaMedicine,
      currentAdminMedicine: adminMedicine
    });
  }

  handleSearchButtonClick = (settings: ImportSyncDataFilterSettingsModel) => {
    this.setState({
      isLoading: true
    });

    if (settings.importDataStatusId && settings.importDataStatusId < 1)
      settings.importDataStatusId = undefined;

    if (settings.syncDataStatusId && settings.syncDataStatusId < 1)
      settings.syncDataStatusId = undefined;

    this.dataSyncService.getAllImported(initFrom, numberOfRows, settings).then(
      (data: ImportDataListModel) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          importedRows: data.importedMedicineData,
          totalRecordsCount: data.totalRecordsCount,
          importDataFiterSettings: settings
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  importDataClick = () => {
    this.setState({
      isLoading: true
    });

    this.dataSyncService.importRawData()
      .then(
        (data: ImportDataResultModel) => {
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  syncDataClick = () => {
    this.setState({
      isLoading: true
    });

    this.dataSyncService.syncData()
      .then(
        (data: SyncDataResultModel) => {
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  updateDataClick = () => {
    this.setState({
      isLoading: true
    });
    this.dataSyncService.updateData()
      .then(
        (data: UpdateDataResultModel) => {
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  showAddNewDialog = (show: boolean) => {
    let contentList = new Array<EmaDataRowContentModel>(0);
    let newDataRow = new EmaDataRowModel();
    const langKeys = HelperFunctions.getEnumKeys(Lang);

    langKeys.map(k => {
      let content = new EmaDataRowContentModel();
      content.langId = parseInt(Lang[k]);
      content.eparPlainText = '';
      contentList.push(content);
    });

    newDataRow.rowContent = contentList;
    this.setState({
      currentRawData: newDataRow,
      isVisibleAddNewDialog: show
    })
  };

  handleAddNewCancelButton = () => {
    this.showAddNewDialog(false)
    this.getAll(this.state.from, this.state.numberOfRows);
  }

  importSingleMedicineClick = (rawData: EmaDataRowModel) => {
    // this.setState({
    //   currentRawData: rawData,
    //   isLoading: true
    // });

    // this.dataSyncService.importSingleMedicine(rawData)
    //   .then(
    //     (data) => {
    //       this.showAddNewDialog(false);
    //       this.setState({
    //         isLoading: false
    //       });
    //     },
    //     error => {
    //       this.showAddNewDialog(false);
    //       this.setState({
    //         error,
    //         isLoading: false
    //       });
    //     }
    //   );
  }

  public render() {
    const { isLoading, error, importedRows, currentImportedMedicine, currentAdminMedicine } = this.state;

    return (
      <>
        <div>
          {isLoading ? <Spinner /> : null}
          {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
          {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
          <Growl ref={(el) => this.growl = el} />

          <Toolbar style={{ marginTop: '10px', marginBottom: '10px' }}>
            <div style={{ marginTop: "10px", marginBottom: '10px' }}>
              <h3>Import / Sync data</h3>
            </div>
            <Button
              style={{ marginRight: "10px", marginBottom: "5px", width: 'auto' }}
              icon="pi pi-download"
              className="p-button-success"
              type="button"
              label="Import all"
              tooltip="Import raw data"
              tooltipOptions={{ position: 'top' }}
              onClick={this.importDataClick}
            />
            <Button
              style={{ marginRight: "10px", marginBottom: "5px", width: 'auto' }}
              icon="pi pi-refresh"
              className="p-button-success"
              type="button"
              label="Synchronize all"
              tooltip="Synchronize imported data"
              tooltipOptions={{ position: 'top' }}
              onClick={this.syncDataClick}
            />
            <Button
              style={{ marginRight: "10px", marginBottom: "5px", width: 'auto' }}
              icon="pi pi-pencil"
              className="p-button-success"
              type="button"
              label="Update all"
              tooltip="Update medicines"
              tooltipOptions={{ position: 'top' }}
              onClick={this.updateDataClick}
            />
            <Button
              style={{ marginRight: "10px", marginBottom: "5px", width: 'auto', float: 'right' }}
              //icon="pi pi-pencil"
              className="p-button-success"
              type="button"
              label="Add new"
              tooltip="Add single medicine"
              tooltipOptions={{ position: 'top' }}
              onClick={() => this.showAddNewDialog(true)}
            />
          </Toolbar>

          <div>
            <ImportDataFilter
              onSearchClick={this.handleSearchButtonClick}
              totalRecordsCount={this.state.totalRecordsCount}
            />
          </div>

          <div>
            <DataTable
              value={importedRows}
              paginator={true}
              lazy={true}
              rows={this.state.numberOfRows}
              totalRecords={this.state.totalRecordsCount}
              onPage={(event) => this.handleOnPageClick(event)}
              first={this.state.from}
            >
              <Column
                field="importedMedicineName"
                header="Medicine Name"
              />
              <Column
                field="importedAdditionalTitle"
                header="Additional Title" />
              <Column
                field="importedDataStatusId"
                header="Import Status"
                body={(rowData, column) =>
                  getEnumLabel(rowData.importedDataStatusId, ImportedDataStatus, true)
                }
              />
              <Column
                field="syncDataStatusId"
                header="Synchronization Status"
                body={(rowData, column) =>
                  getEnumLabel(rowData.syncDataStatusId, SyncDataStatus, true)
                }
              />
              <Column
                header="Actions"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-pencil"
                      className="p-button-warning"
                      tooltip="Edit"
                      tooltipOptions={{ position: 'top' }}
                      style={{ marginRight: ".5em" }}
                      onClick={() => this.handleImportedMedicineEditClick(rowData.importedMedicineId)}
                    />
                    {/* <Button
                      type="button"
                      icon="pi pi-trash"
                      className="p-button-danger"
                      tooltip="Remove"
                      tooltipOptions={{ position: 'top' }}
                      onClick={() => this.handleDeleteClick(rowData.importedMedicineId)}
                    /> */}
                  </div>
                }

              />
            </DataTable>
          </div>
        </div>

        {this.state.isVisibleImportDataEditDialog ? (
          <ImportDataEditDialog
            syncClick={this.handleSyncTODBButton}
            updateClick={this.handleUpdateMedicineButton}
            cancelClick={this.handleCancelButton}
            currentImportedMedicine={currentImportedMedicine}
            currentAdminMedicine={currentAdminMedicine}
            isVisible={this.state.isVisibleImportDataEditDialog}
          />
        ) : null}

        {this.state.isVisibleAddNewDialog ? (
          <ImportDataAddNewDialog
            importClick={this.importSingleMedicineClick}
            cancelClick={this.handleAddNewCancelButton}
            isVisible={this.state.isVisibleAddNewDialog}
            currentRawData={this.state.currentRawData}
          />
        ) : null}

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteDataSource(this.state.currentGridMedicine.importedMedicineId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{this.state.currentGridMedicine.importedMedicineName}"?
        </ConfirmDialog>
      </>
    );
  }
}

export default ImportDataContainer;